import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-file-label-view',
  templateUrl: './file-label-view.component.html',
  styleUrls: ['./file-label-view.component.css']
})
export class FileLabelViewComponent implements OnInit, OnChanges {
  @Input() file: File | string;
  imgURL: string | ArrayBuffer;

  constructor() {
  }

  ngOnInit(): void {
    this.update()
  }


  ngOnChanges(changes: SimpleChanges): void {
    const changedFile = changes.file.currentValue;
    if (changedFile === undefined || (changedFile instanceof File && changedFile.type === undefined)) {
      return;
    }
    this.update();

  }

  private update() {
    if (this.file instanceof File) {
      const mimeType = this.file.type;
      if (mimeType.match(/image\/*/) != null) {
        this.readImage(this.file);
      } else {
        this.imgURL = null;
      }
    } else {
      this.imgURL = this.file;
    }
  }

  private readImage(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    };
  }

}
